/**
* @Author: Daniel Rhees <Daniel>
* @Date:   2017-01-27T13:49:57-08:00
* @Email:  daniel@reflexmedia.com
 * @Last modified by:   Daniel
 * @Last modified time: 2017-04-06T13:58:26-07:00
*/



import React, { Component } from 'react';
import Checkbox from '../../common/Checkbox';
import Select from '../../common/Select';
import FilterSection from './FilterSection';
import Rheostat from 'rheostat';

const ANY_DISTANCE = 20000;
const MIN_DISTANCE = 10;
const MAX_DISTANCE = 1000;

class FiltersLivingIn extends Component {

  render() {
    let {RheostatText,Checkbox} = this.props;

    return (
      <FilterSection header="Distance">
        { this.props.distance === ANY_DISTANCE ? null :
            <div>
              <RheostatText>{this.props.distance} miles</RheostatText>
              <Rheostat
                min={MIN_DISTANCE}
                max={MAX_DISTANCE}
                snap={true}
                values={[this.props.distance]}
                snap={true}
                onChange={(e) => { this.props.onChangeDistance(e.values[0]) }}
              /> 
            </div> } 

            <Checkbox label={'Any distance'} onChange={(e) => { 
              let newDistance = Boolean(e.target.value==="false") ? ANY_DISTANCE : MIN_DISTANCE;
              this.props.onChangeDistance(newDistance);
            }} value={Boolean(this.props.distance===ANY_DISTANCE)} />

        </FilterSection>
    );
  }
}

export default FiltersLivingIn;



// WEBPACK FOOTER //
// ./src/components/pages/Search/FiltersLivingIn.jsx